
"use client";

import React from "react";
import Lottie from "react-lottie";
import animationData from "./NoData.json";
import "./NoData.css";

const NoData = ({ text = "No Data Found", subText = "" }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <section className="no-data-wrapper">
      <div className="no-data-wrapper__content">
        <div className="no-data-wrapper__lottie">
          <Lottie options={defaultOptions} />
        </div>

        {text && (
          <h3 className="no-data-wrapper__title">
            {text}
          </h3>
        )}

        {subText && (
          <p className="no-data-wrapper__subtitle">
            {subText}
          </p>
        )}
      </div>
    </section>
  );
};

export default NoData;

